export default __webpack_public_path__ + "static/media/instagram.fe5e0809.svg";